import { useQSSKey } from "@contexts/QueryStringStorageContext";
import { useQueryStringStorage } from "@hooks/useQueryStringStorage/useQueryStringStorage";
import FilterSelect, {
    FilterSelectOptionType,
} from "@jmc/solid-design-system/src/components/molecules/FilterSelect/FilterSelect";
import React from "react";
import { useTranslation } from "react-i18next";
import { useRefinementList, UseRefinementListProps } from "react-instantsearch";

interface CustomRefinementListProps extends UseRefinementListProps {
    relativePosition?: boolean;
    showCount?: boolean;
    getTranslation?: (item: string, t: (item: string) => string) => string;
}

/**
 * TODO: Rebranding: Delete this component after the rebranding
 */
export const CustomRefinementList = (props: CustomRefinementListProps): JSX.Element => {
    const { items, refine } = useRefinementList(props);
    const { relativePosition = false, showCount = false, getTranslation = (item: string) => item } = props;
    const { t } = useTranslation();
    const qss = useQueryStringStorage();
    const qssKey = useQSSKey();

    let selectedOptionCount = 0;
    const options = items.map((item) => {
        const filter = {
            label: getTranslation(item?.label, t),
            value: item?.value,
            isSelected: item?.isRefined,
            count: item.count,
        };

        if (item?.isRefined) selectedOptionCount++;

        return filter;
    });

    // Sort options after being translated
    options.sort((a, b) => (a?.label?.toUpperCase() < b?.label?.toUpperCase() ? -1 : 1));

    const defaultText =
        props?.attribute === "specialty" ? `${t("Diseases", { ns: "common" })}` : getTranslation(props?.attribute, t);
    const placeholder = showCount && selectedOptionCount > 0 ? `${defaultText} (${selectedOptionCount})` : defaultText;

    return (
        <FilterSelect
            isMulti={true}
            placeholder={placeholder}
            options={options}
            clickAction={(filter: FilterSelectOptionType) => {
                qss.handleQueryParam(qssKey, props.attribute, filter?.value);
                refine(filter?.value);
            }}
            relativePosition={relativePosition}
            enableClearFilter={false}
        />
    );
};

export default CustomRefinementList;
